import { z } from 'zod/v4';

export const companyTypeOptions = [
  'None',
  'Other',
  'Paying Customer',
  'Partner',
  'Trial',
  'Internal Test',
] as const;

export const companyTypeSchema = z.enum(companyTypeOptions);

export type CompanyType = z.infer<typeof companyTypeSchema>;
